var map = {
	"./department-1.png": 26599,
	"./department-10.png": 36728,
	"./department-11.png": 57874,
	"./department-12.png": 11480,
	"./department-13.png": 7259,
	"./department-14.png": 6271,
	"./department-15.png": 31427,
	"./department-2.png": 89929,
	"./department-3.png": 37190,
	"./department-4.png": 486,
	"./department-5.png": 690,
	"./department-6.png": 44986,
	"./department-7.png": 80000,
	"./department-8.png": 20626,
	"./department-9.png": 10242
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51524;